export function formatFloat(number, decimalPlaces) {
    // if (typeof number !== 'number' || typeof decimalPlaces !== 'number') {
    //     throw new TypeError('Both arguments must be numbers');
    // }

    if (number !== undefined) {
        return number.toLocaleString('cs-CZ', {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });
    } else {
        return null
    }

}

export function czechNumberToNumber(czechStr) {

    if (typeof czechStr === 'number') {
        console.log('number');
        czechStr = formatFloat(czechStr, 2);
    }

    // Ošetření null/undefined
    if (!czechStr || typeof czechStr !== 'string') {
        return NaN;
    }

    // Odstranění bílých znaků na začátku a konci
    const trimmed = czechStr.trim();

    // Nahrazení českého formátu na anglický
    const normalized = trimmed
        .replace(/\s+/g, '')  // odstranění všech bílých znaků
        .replace(',', '.');   // čárka na tečku

    // Kontrola, zda obsahuje pouze číslice, tečku a volitelně znaménko
    if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
        return NaN;
    }

    return Number(normalized);
}


// Weight thresholds in kilograms
const WEIGHT_THRESHOLDS = {
    SINGLE_PERSON: 20,
    TWO_PEOPLE: 70,
    THREE_PEOPLE: 90
};

/**
 * Calculates the required number of people based on the given weight.
 *
 * @param {number} weight - The weight in kilograms (must be >= 0).
 * @return {number} The number of people required (1-4).
 * @throws {Error} If weight is not a valid positive number.
 * @example
 * getRequiredPeopleCount(15); // returns 1
 * getRequiredPeopleCount(50); // returns 2
 */
export function getRequiredPeopleCount(weight) {
    // Input validation
    if (typeof weight !== 'number' || isNaN(weight)) {
        throw new Error('Weight must be a valid number');
    }
    
    if (weight < 0) {
        throw new Error('Weight cannot be negative');
    }
    
    // Apply thresholds
    if (weight <= WEIGHT_THRESHOLDS.SINGLE_PERSON) return 1;
    if (weight <= WEIGHT_THRESHOLDS.TWO_PEOPLE) return 2;
    if (weight <= WEIGHT_THRESHOLDS.THREE_PEOPLE) return 3;
    return 4;
}

/**
 * Validates form by checking DOM elements for validation errors
 * @param {Element} rootElement - The root element to search in (usually this.$el from Vue component)
 * @param {Object} options - Configuration options
 * @param {string} options.invalidSelector - CSS selector for invalid elements
 * @param {boolean} options.scrollToFirst - Whether to scroll to first invalid element
 * @param {boolean} options.focusFirst - Whether to focus first invalid element
 * @param {boolean} options.showConsoleLog - Whether to log results to console
 * @return {boolean} True if valid, false if errors found
 */
export function validateByDOM(rootElement, options = {}) {
    // Default options
    const config = {
        invalidSelector: '.is-invalid, input:invalid, select:invalid, textarea:invalid',
        scrollToFirst: true,
        focusFirst: true,
        showConsoleLog: true,
        ...options
    };

    if (!rootElement) {
        console.warn('validateByDOM: rootElement is required');
        return false;
    }

    const invalidElements = rootElement.querySelectorAll(config.invalidSelector);
    const hasErrors = invalidElements.length > 0;

    if (hasErrors) {
        if (config.scrollToFirst && invalidElements[0]) {
            // Najít první nevalidní prvek a scrollovat k němu
            invalidElements[0].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }

        if (config.focusFirst && invalidElements[0]) {
            // Malé zpoždění aby proběhl scroll
            setTimeout(() => {
                invalidElements[0].focus();
            }, 300);
        }

        if (config.showConsoleLog) {
            console.log(`Nalezeno ${invalidElements.length} nevalidních polí`);
            // Pro debug můžeme vypsat i konkrétní elementy
            invalidElements.forEach((el, index) => {
                console.log(`${index + 1}. Nevalidní element:`, el, 
                           `Name: ${el.name || 'N/A'}`, 
                           `ID: ${el.id || 'N/A'}`);
            });
        }

        return false;
    }

    if (config.showConsoleLog) {
        console.log('Všechna pole jsou validní');
    }

    return true;
}

/**
 * Alternative validation function that works with Vue component context
 * @param {Object} vueComponent - Vue component instance (this)
 * @param {Object} options - Same options as validateByDOM
 * @return {boolean} True if valid, false if errors found
 */
export function validateComponentByDOM(vueComponent, options = {}) {
    if (!vueComponent || !vueComponent.$el) {
        console.warn('validateComponentByDOM: Valid Vue component instance is required');
        return false;
    }
    
    return validateByDOM(vueComponent.$el, options);
}

/**
 * Opens a PDF document in a new browser tab or window.
 * Adds a cache-bypass parameter to the URL to prevent the browser from using a cached version.
 * Logs a warning if the popup is blocked and an error if the URL is invalid or another issue occurs.
 *
 * @param {string} urlPdf - The URL of the PDF file to be displayed.
 * @return {void} No value is returned.
 */
export function showPdfFile(urlPdf) {
  try {
    const finalUrl = new URL(urlPdf);
    finalUrl.searchParams.append('nocache', Date.now());
    const newWindow = window.open(finalUrl.toString(), '_blank')
    if (!newWindow) {
      console.warn('Popup bylo zablokováno')
    }
  } catch (error) {
    console.error('Chyba při otevírání PDF:', error)
  }
}

/**
 * Constructs the full name of a customer by combining the company name, customer name (first and last), and email.
 * Null, undefined, empty strings, and whitespace-only strings are omitted from the result.
 *
 * @param {string} name - The company name of the customer.
 * @param {string} firstName - The first name of the customer.
 * @param {string} lastName - The last name of the customer.
 * @param {string} email - The email address of the customer.
 * @return {string} A string containing the concatenated and normalized full name of the customer. Each part is separated by a comma.
 */
export function getFullCustomerName(name, firstName, lastName, email) {
    // Pomocná funkce pro normalizaci hodnoty (prázdný řetězec = null)
    const normalize = (value) => {
        if (!value || (typeof value === 'string' && value.trim() === '')) {
            return null;
        }
        return value.trim();
    };

    // 1. Sestavíme jméno zákazníka (očištěné o null/undefined/'' a prázdné znaky)
    const customerParts = [lastName, firstName];
    const customerName = customerParts
        .map(normalize)
        .filter(p => p)
        .join(" ");

    // 2. Sestavíme výsledný řetězec z firmy (name), jména a emailu
    const fullParts = [name, customerName || null, email];
    return fullParts
        .map(normalize)
        .filter(p => p)
        .join(", ");
}
